import { Injector } from '@angular/core';
import { BulkSection } from './BulkSection';

export class BulkExportSection extends BulkSection {
  request = 'bulkexportrequests';
  criteriaModel: any;
  placeholderRequest: any = "Search for the export title or status of the requests. Type any character and press [ENTER] to execute the search.";
  repeatersToTransform = [
    'drugingredients',
    'pharmaceuticalforms',
    'atccodes',
    'indicationmeddracodes',
    'organisations',
    'anynames',
    'fullnames',
    'shortnames',
    'genericnames',
    'companynames',
    'evcodes',
  ];

  nonRepeatersToTransform = [
    'qppvs',
    'mfls',
    'ownerorganisations',
    'authorisationcountrycodes',
    'authorisationprocedures',
    'authorisationstatuses',
    'previews'  
  ];

  otherFieldsToTransform = [
    'versionToExport',
    'assessment',
    'art57Format',
    'interimFormat',
    'startDate',
    'endDate',
    'authorisedDevelopment'
  ];

  initialModel = {
    versionToExport: { filterStatus: true, filterData: 6 },
    drugingredients: { filterStatus: false, filterData: [[{}]] },
    pharmaceuticalforms: { filterStatus: false, filterData: [[{}]] },
    atccodes: { filterStatus: false, filterData: [[{}]] },
    indicationmeddracodes: { filterStatus: false, filterData: [[{}]] },
    organisations: { filterStatus: false, filterData: [[{}]] },
    anynames: { filterStatus: false, filterData: [[{}]] },
    fullnames: { filterStatus: false, filterData: [[{}]] },
    shortnames: { filterStatus: false, filterData: [[{}]] },
    genericnames: { filterStatus: false, filterData: [[{}]] },
    companynames: { filterStatus: false, filterData: [[{}]] },
    evcodes: { filterStatus: false, filterData: [[{}]] },
  };

  constructor(injector: Injector){
    super(injector);
    this.criteriaModel = structuredClone(this.initialModel);    
  }

}
